<template>
    <DefaultLayout>
        <template #buttons>
        </template>

        <UserFilterExpiration :filters="filters">
            <h1 class="h5 mt-2">
                {{ i18n('Users soon to expire') }}
                <span class="small text-muted" v-if="!pagination?.total">({{ users.length }})</span>
                <span class="small text-muted" v-else>({{ pagination?.total }})</span>
            </h1>
            <template #buttons>
                <UserExpireAction cssClass="ms-1" @created="reload"
                    v-if="can('USER_MANAGE') || can('RESPONSIBLE_USER_MANAGE')" @expire="expire" @renewal="renewal" />
            </template>
        </UserFilterExpiration>
        <UserList :pagination="pagination" :users="users" :loading="loading"
            :autoLazyLoad="!pagination.singlePage && !!pagination.nextPageURI" @deleted="reload"
            @updating="loading = true" @updated="reload" @next="nextPage" @goToPage="goToPage" @orderBy="orderBy"
            :expiresSoon="true" @updateSelection="handleSelection" @ItemExpire="expireUser"
            @ItemRenewal="renewalUser" />
    </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import UserExpireAction from "@/components/user/UserExpireAction.vue";
import UserFilterExpiration from "@/components/user/UserFilterExpiration.vue";
import UserList from "@/components/user/UserList.vue";

export default {
    mixins: [paginatedViewMixin,],
    components: {
        DefaultLayout,
        UserExpireAction,
        UserFilterExpiration,
        UserList,
    },
    data() {
        return {
            listPropertyName: 'users',
            apiResource: `users`,
            users: [],
            intialFilterExpirationDate: true,
            checkedItems: [],
            renewal_month: 3,
        }
    },
    created() {
        if (this.intialFilterExpirationDate) {
            const now = new Date();
            now.setMonth(now.getMonth() + 3);
            now.setDate(now.getDate() - 5);
            this.filters.expires_to = now.toISOString().split('T')[0];
        }

        if (this.can('RESPONSIBLE_USER_MANAGE')) {
            this.filters.responsibleExternalUser = this.$root.loggedUser.id;
        }

        this.filters.is_deleted = 0;
    },
    mounted() {
        this.$root.setPageTitle(this.i18n('Users'));

        api.auth().then((user) => {
            this.$root.loggedUser = user;

            if (!user.loggedIn) {
                return; // Layout non-anonymous will handler redirect
            }

            if (this.can('RESPONSIBLE_USER_MANAGE')) {
                this.filters.responsibleExternalUser = this.$root.loggedUser.id;
            }

            if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
                this.$router.push({ name: 'Index', });
                return;
            }

            this.load();
        });
    },
    watch: {
        params: {
            handler() {
                this.pagination.loadPages = 1;
                this.reload();
            },
            deep: true,
        },
    },
    methods: {
        extendApiParams(params) {
            params.acl = 'user';

            if (!params.company) {
                delete params.office;
                delete params.department;
            }
        },
        orderBy(column) {
            this.filters.orderBy = column;
        },
        renewal() {
            this.checkedItems.forEach((id) => {
                let data = {
                    'id': id,
                    'expires': this.renewal_month,
                };

                api.put(`users/${id}`, data).then(() => {
                    this.reload();
                });
            });
        },
        expire() {
            this.checkedItems.forEach((id) => {
                let data = {
                    'id': id,
                    'ending_date': new Date().toISOString().split('T')[0],
                };

                api.put(`users/${id}`, data).then(() => {
                    this.reload();
                });
            });
        },
        handleSelection(selection) {
            const index = this.checkedItems.findIndex(item => item === selection.id);
            if (selection.checked) {
                if (index === -1) {
                    this.checkedItems.push(selection.id);
                }
            } else {
                if (index !== -1) {
                    this.checkedItems.splice(index, 1);
                }
            }
        },
        expireUser(user) {
            let data = {
                'id': user.id,
                'ending_date': new Date().toISOString().split('T')[0],
            };
            api.put(`users/${user.id}`, data).then(() => {
                this.reload();
            });
        },
        renewalUser(user) {
            let data = {
                'id': user.id,
                'expires': this.renewal_month,
            };
            api.put(`users/${user.id}`, data).then(() => {
                this.reload();
            });
        },
    },
};
</script>